import React, { Component, Fragment, Suspense } from "react";
import { Switch, Route, BrowserRouter as Router, } from "react-router-dom";


//Component
import HomePage3 from "./component/home3";

import "./App.css";
import "./Vendor.js";

import { IntlProvider } from "react-intl";
import AdminDashboard from "./component/admin/principal";
import AdminLayoutRouter from './layouts/adminLayout';
import ErrorBoundary from './shared/components/ErrorBoundary/ErrorBoundary';


export default function App() {
  return (
    <IntlProvider locale="en">
      <Fragment>
        <ErrorBoundary>
          <Suspense fallback={<></>}>
            <Router>
              <Switch>
                <Route exact path="/" component={HomePage3} />

                <AdminLayoutRouter
                  path="/admin-panel/"
                  component={AdminDashboard}
                  authOnly={true}
                  roles={["admin"]}
                />

              </Switch>
            </Router>
          </Suspense>
        </ErrorBoundary>
      </Fragment>
    </IntlProvider>
  );
}
